export var AttributeLevel;

!function(AttributeLevel) {
    AttributeLevel[AttributeLevel.Default = 0] = "Default", AttributeLevel[AttributeLevel.Theme = 1] = "Theme", 
    AttributeLevel[AttributeLevel.Chart = 2] = "Chart", AttributeLevel[AttributeLevel.Base_Series = 3] = "Base_Series", 
    AttributeLevel[AttributeLevel.Series = 4] = "Series", AttributeLevel[AttributeLevel.Mark = 5] = "Mark", 
    AttributeLevel[AttributeLevel.User_Chart = 6] = "User_Chart", AttributeLevel[AttributeLevel.User_Series = 7] = "User_Series", 
    AttributeLevel[AttributeLevel.User_Mark = 8] = "User_Mark", AttributeLevel[AttributeLevel.User_SeriesStyle = 9] = "User_SeriesStyle", 
    AttributeLevel[AttributeLevel.Built_In = 99] = "Built_In";
}(AttributeLevel || (AttributeLevel = {}));
//# sourceMappingURL=attribute.js.map